export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS"
export const PAYMENT_SUCCESS_SUCCESS = "PAYMENT_SUCCESS_SUCCESS"
export const PAYMENT_SUCCESS_FAIL = "PAYMENT_SUCCESS_FAIL"
export const PAYMENT_SUCCESS_CLEAR = "PAYMENT_SUCCESS_CLEAR"